var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"my-0 py-0",attrs:{"fluid":""}},[_c('v-tabs',[_c('v-tab',[_vm._v("Usuarios")]),_c('v-tab',[_vm._v("Proyectos")]),_c('v-tab-item',[_c('Usuarios')],1),_c('v-tab-item',[_c('Proyectos')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }